import axios from 'axios';

let prefix = "/user"
let prefix_auth = "/auth"

const UserApi = {
	
	getUserList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getUserInfo(id, payload){
		return axios.get( prefix + "/get/"+id, {params: payload})
	},
	updateUserProfile(payload){
		return axios.post( prefix + "/update", payload)
	},
	updateUserPassword(payload){
		return axios.post( prefix + "/profile-password/update", payload)
	},
	updatePassword(payload){
		return axios.post( prefix + "/password/update", payload)
	},
	sendAccountActivation(payload){
		return axios.post( prefix + "/activation-email/send", payload)
	},
	verifyEmail(payload){
		return axios.post( prefix + "/verifyEmailToken", payload)
	},	
	archiveUser(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	updateRole(payload){
		return axios.post( prefix + "/update-role", payload)
	},
	exportUserList(payload){
		return axios.get( prefix + "/export-user-list", {params: payload})
	},
	forgotPassword(payload){
		return axios.post( prefix_auth + "/reset-password", payload)
	},
	updateUserStatus(payload){
		return axios.post( prefix + "/status/update", payload)
	},
	getUserStatusRef(payload){
		return axios.get( prefix + "/status-list", {params: payload})
	},
}

export default UserApi;